import React from 'react'

export default function NotFoundPage() {
    return (
        <div style={{ textAlign: 'center', paddingTop: '50px' }}>
            <h1>404 - Page Not Found</h1>
            <p>The page you are looking for does not exist.</p>
        </div>
    )
}
